<template>
  <div>
    <v-card elevation="0" outlined class="pa-4 ma-4">
      <v-row class="pa-2" no-gutters>
        <v-col class="d-flex align-center" cols="2">
          <UserAvatarPicker :user="staff" type="staff" />
        </v-col>
        <v-col class="d-flex flex-column" cols="8">
          <v-row no-gutters class="flex-column">
            <p class="text-h5 primary--text mb-0">{{ staff.name }}</p>
          </v-row>
          <v-row>
            <v-col cols="3" class="py-2 d-flex flex-column justify-end">
              <p class="text-caption mb-0">Tên đăng nhập</p>
              <p class="text-subtitle-2 mb-0">{{ staff.code }}</p>
            </v-col>
            <v-col cols="3" class="py-2 d-flex flex-column justify-end">
              <p class="text-caption mb-0">Vai trò</p>
              <p class="text-subtitle-2 mb-0">{{ staff | _get('role.description') }}</p>
            </v-col>
            <v-col cols="3" class="py-2 d-flex flex-column justify-end">
              <p class="text-caption mb-0">Email</p>
              <p class="text-subtitle-2 mb-0">{{ staff.email ? staff.email : 'Không có' }}</p>
            </v-col>
            <v-col cols="3" class="py-2 d-flex flex-column justify-end">
              <p class="text-caption mb-0">SĐT</p>
              <p class="text-subtitle-2 mb-0">{{ staff.phone ? staff.phone : 'Không có' }}</p>
            </v-col>
          </v-row>
        </v-col>
        <v-col class="d-flex align-end justify-end" cols="2">
          <v-btn @click="detailState = !detailState" small color="primary" outlined>Hồ sơ chi tiết</v-btn>
        </v-col>
      </v-row>
      <UpdateStaffDialog :state="editState" :staff="staff" />
      <StaffDetailDialog :state="detailState" :staff="staff" @edit="editState = !editState" />
    </v-card>
    <div v-if="$auth.policies['delete-staff']" class="text-center">
      <v-btn class="mb-4" @click="remove" color="red" outlined>Xóa người dùng</v-btn>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import UpdateStaffDialog from '@/modules/staff/UpdateStaffDialog.vue'
import UserAvatarPicker from '@/components/basic/picker/UserAvatarPicker'
import StaffDetailDialog from '@/modules/staff/StaffDetailDialog.vue'

export default {
  components: {
    UpdateStaffDialog,
    UserAvatarPicker,
    StaffDetailDialog
  },
  props: {},
  data() {
    return {
      editState: false,
      detailState: false
    }
  },
  async created() {
    await this.fetchStaff(this.$route.params.id)
  },
  computed: {
    ...mapState('staff', ['staff'])
  },
  methods: {
    ...mapActions('staff', ['fetchStaff', 'removeStaff']),
    async remove() {
      this.$dialog.confirm({
        title: 'Xóa Người Dùng',
        text: `Bạn Có chắc muốn xóa người dùng này.?`,
        okText: 'Có',
        cancelText: 'Không',
        done: async () => {
          this.$loading.active = true
          await this.removeStaff(this.staff)
          this.$loading.active = false

          this.$router.push(`/staffs/`)
        }
      })
    }
  }
}
</script>
<style scoped>
.v-subheader {
  width: 30%;
}
</style>
